import { apiClient } from '_app'
import { ApiResponse } from 'dtos'
import { StatementOfConformitySignatureDto } from 'dtos/people'
import { base64ToArrayBuffer } from 'utils'

export const getStatementOfConformitySignature = (personGuid: string) =>
  apiClient
    .get<ApiResponse<StatementOfConformitySignatureDto>>(`/api/people/${encodeURIComponent(personGuid)}/statement-of-conformity-signature`)
    .then(res => res.data)

export const downloadStatementOfConformitySignatureFile = (personGuid: string, fileName: string) =>
  apiClient.get(`/api/people/${encodeURIComponent(personGuid)}/statement-of-conformity-signature/${encodeURIComponent(fileName)}`).then(res => {
    const buffer = base64ToArrayBuffer(res.data)
    const blob = new Blob([buffer], { type: 'image/png' })
    const objectURL = window.URL.createObjectURL(blob)
    window.open(objectURL)
    window.URL.revokeObjectURL(objectURL)
  })

export const updateStatementOfConformitySignature = (personGuid: string, data: StatementOfConformitySignatureDto) => {
  const formData = new FormData()

  if (data.statementOfConformitySignatureFile) {
    formData.append('statementOfConformitySignatureFile', data.statementOfConformitySignatureFile)
  }

  return apiClient<ApiResponse<StatementOfConformitySignatureDto>>({
    data,
    headers: { 'Content-Type': 'multipart/form-data' },
    method: 'put',
    url: `/api/people/${encodeURIComponent(personGuid)}/statement-of-conformity-signature`
  }).then(res => res.data)
}
